/**
 * Carga
 * @author Simpli CLI generator
 */
import {
  $,
  HttpBody,
  ID,
  Resource,
  Resp,
  ValidationMaxLength,
} from 'simpli-web-sdk'
import CargaPedidoNroFiscalSchema from '@/schema/CargaPedidoNroFiscal.schema'

export default class CargaPedidoNroFiscal extends Resource {

  static async persistCargaOrderNumber(request?: CargaPedidoNroFiscal[],
                                       spinner = 'persistCarga'): Promise<Resp<number[]>> {
    const fetch = async () => await new HttpBody<number[]>(Array).POST(`/user/carga/pedido`, request)
    return await $.await.run(fetch, spinner)
  }

  readonly $name: string = 'CargaPedidoNroFiscal'

  readonly $endpoint: string = '/user/carga{/id}'

  get $schema() {
    return CargaPedidoNroFiscalSchema(this)
  }

  get $id() {
    return this.idCargaPk
  }

  set $id(val: ID) {
    this.idCargaPk = val
  }

  idCargaPk: ID = 0

  @ValidationMaxLength(255)
  nroNotaFiscal: string = ''

  xpedido: string | null = null
}
